import { useQuery } from "@tanstack/react-query"

import { FormSelect } from "#components/form/index.ts"
import { graphql } from "#gql"
import { queryKeys } from "#lib/query-keys.ts"
import { client } from "#utils/graphql-client.ts"

const AircraftCategoriesDocument = graphql(/* GraphQL */ `
  query AircraftCategories {
    aircraftCategories
  }
`)

interface FormAircraftCategorySelectProps {
  value: string | undefined
  onChange: (value: string | null) => void
  name?: string
  label?: string
  placeholder?: string
  disabled?: boolean
  className?: string
  error?: string
}

export const FormAircraftCategorySelect = ({
  value,
  onChange,
  name,
  label = "Aircraft category",
  placeholder = "Add aircraft category",
  disabled,
  className,
  error,
}: FormAircraftCategorySelectProps) => {
  const { data } = useQuery({
    queryKey: queryKeys.aircraft.categories(),
    queryFn: () => client.request(AircraftCategoriesDocument),
  })

  const options = (data?.aircraftCategories ?? []).map((category) => ({
    value: category,
    label: category,
  }))

  return (
    <FormSelect
      value={value}
      onChange={onChange}
      name={name}
      label={label}
      placeholder={placeholder}
      options={options}
      disabled={disabled}
      className={className}
      error={error}
    />
  )
}
